import {LOCALE_ID, NgModule} from '@angular/core';
import {HashLocationStrategy, LocationStrategy, registerLocaleData} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AppLayoutModule} from './layout/app.layout.module';
import {FormsModule} from '@angular/forms';
import {ImageModule} from 'primeng/image';
import localeEsSV from "@angular/common/locales/es-SV";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {RippleModule} from "primeng/ripple";
import {LoggingInterceptor} from "./shared/components/interceptors/logging.interceptor";
import {ErrorInterceptor} from "./shared/components/interceptors/error.interceptor";
import {TimeoutInterceptor} from "./shared/components/interceptors/timeout.interceptor";
import {RequestTimingInterceptor} from "./shared/components/interceptors/request.timing.interceptor";
import {SessionIdInterceptor} from "./shared/components/interceptors/session-id.interceptor";
import {CorsInterceptor} from "./shared/components/interceptors/cors.interceptor";
import {PrimeNgModule} from "./shared/prime-ng/prime-ng.module";
import {ProyectosModule} from "./users/proyectos/proyectos.module";
import {
    GeneralesProyectoComponent
} from "./users/proyectos/components/ver-proyecto/generales-proyecto/generales-proyecto.component";
import {FormularioAComponent} from "./users/tramites/components/formulario-a/formulario-a.component";
import {FormularioBComponent} from "./users/tramites/components/formulario-b/formulario-b.component";
import {FormularioCComponent} from "./users/tramites/components/formulario-c/formulario-c.component";
import {TramitesModule} from "./users/tramites/tramites.module";
import {SharedModule} from "./shared/shared.module";
import {FullCalendarModule} from "@fullcalendar/angular";
import {DuplicateCallInterceptor} from "./shared/components/interceptors/duplicate-call.interceptor";
import {AuthInterceptor} from "./shared/components/interceptors/auth.interceptor";
import {PdfJsViewerModule} from "ng2-pdfjs-viewer";
import {SolicitudRequisitosComponent} from "./shared/components/solicitud-requisitos/solicitud-requisitos.component";
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app-routing.module';
import { RegistroProfesionalesModule } from './users/registro-profesionales/registro-profesionales.module';

registerLocaleData(localeEsSV)

@NgModule({
    declarations: [
        AppComponent,
        FormularioAComponent,
        FormularioBComponent,
        FormularioCComponent
    ],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: RequestTimingInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: SessionIdInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: CorsInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: DuplicateCallInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        {provide: LOCALE_ID, useValue: 'es-SV'},
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        provideRouter(
            routes,
            withComponentInputBinding()
          )
    ],
    bootstrap: [AppComponent],
    imports: [
        AppLayoutModule,
        AppRoutingModule,
        FormsModule,
        ImageModule,
        PrimeNgModule,
        ProyectosModule,
        RegistroProfesionalesModule,
        GeneralesProyectoComponent,
        RippleModule,
        TramitesModule,
        SharedModule,
        FullCalendarModule,
        PdfJsViewerModule,
        SolicitudRequisitosComponent
    ]
})
export class AppModule {
}
